import Vue from "vue";
import ApiService from "@/core/services/api.service";

import {
  UPLOAD_REQUEST_LETTER_DIRECT,
  GENERATE_REQUEST_LETTER_UPLOAD_TOKEN,
  GET_REQUEST_LETTER_UPLOAD_STATUS,
  UPLOAD_REQUEST_LETTER_MOBILE,
  LINK_REQUEST_LETTER_TO_APPOINTMENT
} from "../actions.type";

// A network failure/timeout has no err.response, so this always yields a
// usable error object instead of crashing (and silently hanging the caller)
// when trying to read response.data off undefined.
function extractError(err) {
  if (err && err.response && err.response.data) return err.response.data;
  return { msg: "Network error. Please check your connection and try again." };
}

const actions = {
  [UPLOAD_REQUEST_LETTER_DIRECT](context, { file, attorney_email }) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("attorney_email", attorney_email || "");
    return new Promise((resolve, reject) => {
      Vue.axios
        .post("upload/request-letter-direct/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 60000
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  },
  [GENERATE_REQUEST_LETTER_UPLOAD_TOKEN](context, attorney_email) {
    return new Promise((resolve, reject) => {
      ApiService.post("generate/request-letter-upload-token/", {
        attorney_email: attorney_email || ""
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  },
  [GET_REQUEST_LETTER_UPLOAD_STATUS](context, token) {
    return new Promise((resolve, reject) => {
      ApiService.get("get/request-letter-upload-status/" + token)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  },
  [UPLOAD_REQUEST_LETTER_MOBILE](context, { token, file }) {
    const formData = new FormData();
    formData.append("file", file);
    return new Promise((resolve, reject) => {
      Vue.axios
        .post("upload/request-letter/" + token + "/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 60000
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  },
  [LINK_REQUEST_LETTER_TO_APPOINTMENT](context, { request_letter_id, appointment_id, appointment_number }) {
    return new Promise((resolve, reject) => {
      ApiService.post("link/request-letter-to-appointment/", {
        request_letter_id,
        appointment_id,
        appointment_number
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(err => {
          reject(extractError(err));
        });
    });
  }
};

export default {
  actions
};
